import React from "react";
import {
  Box,
  useMediaQuery,
  TextField,
} from "@mui/material";
// import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";

const FopFilterComponent = ({ filter, setFilter }) => {
  // const backgroundColor= {'&.Mui-selected':{
  //   backgroundColor:"inherit",
  //  }}

  const isMobile = useMediaQuery("(max-width: 600px)");
  const isTablet = useMediaQuery("(min-width:768px) and (max-width:1025px)");

  const handleFilter = (e) => {
    setFilter(e.target.value);
  }

  // const handleClearFilter = (filterToRemove) => {
  //   setSelectedFilters((prevFilters) =>
  //     prevFilters.filter((filter) => filter !== filterToRemove)
  //   );
  // };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        alignItems: isMobile ? "stretch" : "center",
        justifyContent: isMobile ? "center" : "space-between",
        flexWrap: isMobile ? "wrap" : "nowrap",
        // gap: isTablet ? 2 : 0,
        mt:isTablet ? "10px" : 0,
        marginBottom: 2,
        width: isMobile ? "100%" : "auto",
      }}
    >
          {/* FOP Search filter */}
          <TextField
            variant="standard"
            size="small"
            placeholder="Search"
            value={filter}
            onChange={handleFilter}
            InputProps={{
              startAdornment: (
                <SearchIcon
                  sx={{
                    mr: 1,
                    width: "19.7px",
                    height: "19.7px",
                    color: "#1460AA",
                    mb: "5px"
                  }}
                />
              ),
              sx: {
                pb:"5px",
                "& input::placeholder": {
                  color: "#000000",
                  fontWeight: 600,
                  fontFamily: "Open Sans",
                  opacity: 1,
                },
                "&.MuiInput-underline:before": {
                  borderBottom: "1px solid #C9CACC",
                },
              },
            }}
          ></TextField>
        </Box>
    //    </Box>
    // </Box> 
  );
};

export default FopFilterComponent;
